import {Injectable} from '@angular/core';
import { StatusCode } from '../constants/status-code.enum';

@Injectable({
  providedIn: 'root'
})
export class ConvertStatusCodeService {

  constructor() {
  }

  public static getClassByCode(status, prefix?) {
    if (StatusCode.RUNNING === status || status === true || StatusCode.ACTIVE === status) {
      return prefix ? `${prefix}-success` : 'badge-success';
    } else if (status === false) {
      return prefix ? `${prefix}-warning` : 'badge-warning';
    } else if (StatusCode.ERROR === status) {
      return prefix ? `${prefix}-danger` : 'badge-danger';
    } else if (StatusCode.INACTIVE === status) {
      return prefix ? `${prefix}-secondary` : 'badge-secondary';
    }
  }
}
